import styled from '@emotion/styled'

import media from '../../../../styles/media'

const S = {}

S.Video = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding-inline: var(--arrow-offset);

  .video-container {
    position: relative;
    width: 100%;
    height: 56.25vw;
    min-height: 11.75rem;
    max-height: 30.75rem;
    transform: translateY(-1.25rem);

    ${media.sm`
      transform: translateY(-0.625rem);
    `};

    ${media.md`
      transform: translateY(0);
    `};
  }

  .video-player {
    position: absolute;
    padding: 0;
    margin: 0;
  }

  .thumbnail {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 50.133333vw;
    max-width: 54.375rem;
    max-height: 30.75rem;
  }
`

export default S
